var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.paymentRequired
    ? _c(
        "div",
        {
          staticClass: "brand-agreement-surface brand-agreement-payment",
          style: _vm.paymentStyle,
          attrs: { id: _vm.item.id },
          on: {
            click: function($event) {
              return _vm.$emit("click", $event)
            }
          }
        },
        [
          _vm.showPaymentElement
            ? _c("div", [
                _c("div", { attrs: { id: "payment-element" } }),
                _vm._m(0)
              ])
            : _vm.verification
            ? _c("div", { staticClass: "text-left font-14" }, [
                _c("div", { staticClass: "font-16 brand-medium" }, [
                  _vm._v(_vm._s(_vm.$t("agreement-payment.verify-title")))
                ]),
                _c("div", { staticClass: "mt-1" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          _vm.verification.type === "amounts"
                            ? "agreement-payment.verify-amounts"
                            : "agreement-payment.verify-descriptor-code"
                        )
                      ) +
                      " "
                  )
                ]),
                _vm.verification.arrivalDate
                  ? _c("div", { staticClass: "mt-1 font-gray_80" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("agreement-payment.verify-arrival", {
                              date: _vm.DateTime.fromJSDate(
                                _vm.verification.arrivalDate
                              ).toLocaleString(_vm.DateTime.DATE_MED)
                            })
                          ) +
                          " "
                      )
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "row-format gap-2 align-center mt-3" },
                  [
                    _vm.verification.type === "amounts"
                      ? _vm._l(_vm.verificationAmounts, function(
                          amount,
                          index
                        ) {
                          return _c("v-text-field", {
                            key: index,
                            attrs: {
                              label: _vm.$t(
                                index === 0
                                  ? "agreement-payment.first-amount"
                                  : "agreement-payment.second-amount"
                              ),
                              placeholder: "0.32",
                              inputmode: "decimal",
                              "hide-details": "",
                              dense: "",
                              outlined: "",
                              "persistent-placeholder": ""
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.verifyMicrodeposits.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.verificationAmounts[index],
                              callback: function($$v) {
                                _vm.$set(_vm.verificationAmounts, index, $$v)
                              },
                              expression: "verificationAmounts[index]"
                            }
                          })
                        })
                      : _c("v-text-field", {
                          attrs: {
                            label: _vm.$t("agreement-payment.descriptor-code"),
                            placeholder: "SM11AA",
                            maxlength: "6",
                            "hide-details": "",
                            dense: "",
                            outlined: "",
                            "persistent-placeholder": ""
                          },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.verifyMicrodeposits.apply(
                                null,
                                arguments
                              )
                            }
                          },
                          model: {
                            value: _vm.verificationCode,
                            callback: function($$v) {
                              _vm.verificationCode = $$v
                            },
                            expression: "verificationCode"
                          }
                        }),
                    _c(
                      "button",
                      {
                        staticClass:
                          "agreement-finish row-format align-center gap-2",
                        attrs: { type: "button", disabled: _vm.verifying },
                        on: { click: _vm.verifyMicrodeposits }
                      },
                      [
                        _vm.verifying
                          ? _c("v-progress-circular", {
                              attrs: {
                                indeterminate: "",
                                size: "16",
                                width: "2"
                              }
                            })
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            style:
                              "font-family: '" +
                              _vm.agreement.styles.h1.fontFamily +
                              "'"
                          },
                          [_vm._v(_vm._s(_vm.$t("agreement-payment.verify")))]
                        )
                      ],
                      1
                    )
                  ],
                  2
                ),
                _vm.verificationError
                  ? _c(
                      "div",
                      {
                        staticClass: "mt-2 payment-verification__error",
                        attrs: { role: "alert" }
                      },
                      [_vm._v(_vm._s(_vm.verificationError))]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "row-format gap-3 mt-2 align-center" },
                  [
                    _vm.verification.hostedUrl
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.verification.hostedUrl,
                              target: "_blank",
                              rel: "noopener"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("agreement-payment.verify-on-stripe")
                                ) +
                                " "
                            )
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.checkVerification.apply(null, arguments)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("agreement-payment.check-status")))]
                    ),
                    _vm._m(1)
                  ]
                )
              ])
            : _c(
                "div",
                { staticClass: "row-format text-left align-center font-14" },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "span",
                        { staticStyle: { "text-transform": "capitalize" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "agreement-payment.status-" + _vm.statusKey
                                )
                              ) +
                              " - " +
                              _vm._s(
                                _vm.$formatters.dollars(
                                  _vm.item.stripePaymentIntent.amount / 100,
                                  true,
                                  true,
                                  _vm.item.stripePaymentIntent.currency
                                )
                              )
                          ),
                          _vm.paymentMethodLabel
                            ? [_vm._v(" - " + _vm._s(_vm.paymentMethodLabel))]
                            : _vm._e()
                        ],
                        2
                      ),
                      _c("br"),
                      _vm.item.stripePaymentIntent.timestamp
                        ? [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.DateTime.fromISO(
                                    _vm.item.stripePaymentIntent.timestamp
                                  ).toLocaleString(_vm.DateTime.DATETIME_FULL)
                                )
                            ),
                            _c("br")
                          ]
                        : _vm._e(),
                      _vm.summaryBlockedReason
                        ? _c("div", { staticClass: "font-gray_80" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "agreement-payment.blocked-" +
                                    _vm.summaryBlockedReason
                                )
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm.agreement.invoiceId
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: "/invoice/" + _vm.agreement.invoiceId,
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.agreement.invoiceNumberFormatted)
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._m(2)
                ]
              )
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "text-left mt-3 row-format gap-1 align-center" },
      [
        _c("div", { staticClass: "ml-auto font-14 font-gray_80" }, [
          _vm._v("Pay securely with")
        ]),
        _c("img", {
          attrs: {
            src: "/images/invoices/stripe-logo.svg",
            alt: "Stripe Logo",
            width: "50"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ml-auto row-format gap-1 align-center" }, [
      _c("div", { staticClass: "font-14 font-gray_80" }, [
        _vm._v("Pay securely with")
      ]),
      _c("img", {
        attrs: {
          src: "/images/invoices/stripe-logo.svg",
          alt: "Stripe Logo",
          width: "50"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ml-auto row-format gap-1 align-center" }, [
      _c("div", { staticClass: "ml-auto font-14 font-gray_80" }, [
        _vm._v("Pay securely with")
      ]),
      _c("img", {
        attrs: {
          src: "/images/invoices/stripe-logo.svg",
          alt: "Stripe Logo",
          width: "50"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }